import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { CSSProperties, forwardRef } from "react";
interface LeftGradientBorderProps extends GeneralPropsType {
  id?: string;
  leftWidth?: number;
  background?: "right_to_left" | "left_to_right" | "dark_blue_left_to_right" | "pink_left_to_right" | "pink_left_to_right_136" | "green_rotate_border" | "green_rotate_border_transparent" | "green_rotate_border_transparent_about" | "green_rotate_border_background_gray" | "gray_border" | "info_bg" | "opacity_black" | "light_blue_green" | "orange_orange" | "vision_light" | "green_rotate_border_fiat";
  styleBorder?: "gradient_bottom_border" | "pink_gradient_bottom_border";
  style?: CSSProperties;
}
const LeftGradientBorder = forwardRef<HTMLDivElement, LeftGradientBorderProps>(({
  children,
  className,
  background,
  styleBorder,
  leftWidth = 0,
  ...rest
}, ref) => {
  return <div ref={ref} {...rest} style={{
    ...(rest?.style ?? {})
  }} className={clsx("relative rounded-2xl", styles.container, styles[background ?? "none"], className)}>
                {children}
                <div style={{
      width: `${leftWidth}px`
    }} className={clsx("absolute left-0 top-0 bottom-0", styles[styleBorder ?? "gradient_bottom_border"])}></div>
            </div>;
});
LeftGradientBorder.displayName = "LeftGradientBorder";
export default LeftGradientBorder;